// @flow

/**
 * enrichReportData
 *
 * Transform report data received into format require for tree grid report table.
 *
 * It adds the following prpoerties:
 *   - hierarchy, list of ancestors
 *   - delta, +/- value from last report period i.e. day
 *   - max, max total across the dataset
 *
 * Input:
 *
 * [{
 *    id: number,
 *    parentId: number,
 *    name: string,
 *    periods: Array<{
 *      value: number
 *    }>,
 *    total: number
 * }]
 *
 *
 * Output:
 *
 * [{
 *   id: number,
 *   parentId: number,
 *   name: string,
 *   +hierarchy: Array<string>,
 *   periods: Array<{
 *     value: number,
 *     +delta: number,
 *   }>,
 *   total: number
 *   +max: number
 * }]
 *
 * @param {*} state
 */

export const enrichReportData = (data: Object): Object => {
  const getAncestory = (node: Object, descendants?: Array<string> = []) => {
    const parent = (data.reportData.details || []).find(
      d => d.id === node.parentId && d.id !== null && node.parentId !== null,
    );

    return parent ? getAncestory(parent, [parent.name, ...descendants]) : descendants;
  };

  let max = 0;
  return {
    ...data,
    reportData: {
      ...data.reportData,
      details: (data.reportData.details || [])
        .map(d => {
          if (d.total > max) {
            max = d.total;
          }

          return {
            ...d,
            hierarchy: getAncestory(d, [d.name]),
            periods: d.periods.map((p, i) => ({
              ...p,
              delta: p.value - d.periods[Math.max(0, i - 1)].value,
            })),
          };
        })
        .map(d => {
          return {
            ...d,
            max,
          };
        }),
    },
  };
};
